/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ portals: NonNullable<unknown> }} Property_Unpublish_Confirm_With_PortalsInputs */

const cs_property_unpublish_confirm_with_portals = /** @type {(inputs: Property_Unpublish_Confirm_With_PortalsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Skrýt na webu a odebrat z portálů: ${i?.portals}.`)
};

const en_property_unpublish_confirm_with_portals = /** @type {(inputs: Property_Unpublish_Confirm_With_PortalsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hide on the website and remove from portals: ${i?.portals}.`)
};

/**
* | output |
* | --- |
* | "Hide on the website and remove from portals: {portals}." |
*
* @param {Property_Unpublish_Confirm_With_PortalsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_unpublish_confirm_with_portals = /** @type {((inputs: Property_Unpublish_Confirm_With_PortalsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Unpublish_Confirm_With_PortalsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_unpublish_confirm_with_portals(inputs)
	return cs_property_unpublish_confirm_with_portals(inputs)
});